import * as plugin from '@tableau/dialog-plugin-contract';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { DetailedErrorViewModel } from './DetailedErrorViewModel';
import { NotificationId } from '../gen-src/preslayer/Events';
import { DetailedErrorPresModel } from '../gen-src/preslayer/PresModels';
import { PresentationModel, PresentationLayer, Instance } from '@tableau/preslayer-api-contract';

export class DialogPlugin implements plugin.DialogPlugin {
  private closeDialog: () => void = () => { /* do nothing unless showing */ };
  public showDialog(presModel: PresentationModel, root: HTMLElement, done: () => void): void {
    this.closeDialog = () => {
      ReactDOM.unmountComponentAtNode(root);
      done();
      this.closeDialog = () => { /* do nothing unless showing */ };
    };
    let onCloseRequested = () => {
      setTimeout(
        () => {
          this.closeDialog();
        },
        0);
    };

    ReactDOM.render(
      <RootComponent presLayer={Instance} onClose={onCloseRequested} initialState={presModel as DetailedErrorPresModel} />,
      root);
  }

  public forceCloseDialog(): void {
    this.closeDialog();
  }
}

interface RootProps {
  presLayer: PresentationLayer;
  initialState: DetailedErrorPresModel;
  onClose: () => void;
}

/**
 * The root dialog component.  Provides the dialogs state and a way to update it locally.
 */
class RootComponent extends React.Component<RootProps, DetailedErrorPresModel> {
  private unregisterNotificationHandler: () => void;
  public constructor(props: RootProps) {
    super(props);
    this.unregisterNotificationHandler = props.presLayer.registerNotificationHandler(
      NotificationId.UpdateDetailedErrorDialog,
      (pm: PresentationModel) => { this.setState(pm as DetailedErrorPresModel); } );
    this.applyLocalChanges = this.applyLocalChanges.bind(this);
  }

  private getPresModel(): DetailedErrorPresModel {
    return this.state || this.props.initialState;
  }

  private static cloneObject<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
  }

  private applyLocalChanges(localChangeAction: (pm: DetailedErrorPresModel) => void): void {
    let updatedPresModel = RootComponent.cloneObject(this.getPresModel());
    localChangeAction(updatedPresModel);
    this.setState(updatedPresModel);
  }

  public render(): JSX.Element {
    return <DetailedErrorViewModel presLayer={this.props.presLayer} onClose={this.props.onClose}
      pm={this.getPresModel()} updatePresModel={this.applyLocalChanges} />;
  }

  public componentWillUnmount(): void {
    this.unregisterNotificationHandler?.();
  }
}
